import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';
import VTooltip from 'v-tooltip';
import './css/main.scss';

Vue.config.productionTip = false;

// would be nice to keep it common with _base.css vars
let media_breakpoints = [
	{
		name: 'phone',
		width: 0,
	},
	{
		name: 'tablet',
		width: 769,
	},
	{
		name: 'desktop',
		width: 1025,
	},
];

Vue.use(VTooltip);

new Vue({
	router,
	store,
	render: h => h(App),

	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
			this.onResize(); // init
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			let viewportWidth = window.innerWidth || 0;
			for (let id = media_breakpoints.length - 1; id >= 0; id--) {
				if (media_breakpoints[id].width <= viewportWidth) {
					store.state.app.media = media_breakpoints[id].name;
					break;
				}
			}
			// store.state.app.viewportWidth = viewportWidth;
		},
	},
}).$mount('#app');
